export interface CommonModalOptions {
  title?: string
  body?: string
  okTitle?: string
  okOnly?: boolean
  cancelTitle?: string
  autofocusButton?: 'ok' | 'cancel' | 'close'
  size?: 'sm' | 'md' | 'lg' | 'xl'
  okColor?: 'primary' | 'secondary'
}

export const MODAL_TYPE = {
  alert: 'Alert',
  confirm: 'Confirm'
} as const
export type ModalType = (typeof MODAL_TYPE)[keyof typeof MODAL_TYPE]
